(() => {
  const dialog = document.getElementById('DutComparison');
  const dock = document.querySelector('[data-compare-dock]');
  if (!dialog || !dock || !window.DutProductFacts || !dialog.showModal) return;
  const storageKey = 'dut-compare-v1';
  const root = dialog.dataset.root || '/';
  const tableWrap = dialog.querySelector('[data-compare-table]');
  const status = dialog.querySelector('[data-compare-status]');
  const announcement = document.querySelector('[data-compare-announcement]');
  const differences = dialog.querySelector('[data-compare-differences]');
  const retryButton = dialog.querySelector('[data-compare-retry]');
  const openButton = dock.querySelector('[data-compare-open]');
  let items = [], products = new Map(), request, generation = 0, returnFocus;
  const text = (tag, value, className) => {
    const element = document.createElement(tag);
    if (value != null) element.textContent = String(value);
    if (className) element.className = className;
    return element;
  };
  function productURL(value) {
    try {
      const url = new URL(value, location.origin);
      const match = url.pathname.match(/\/products\/([a-z0-9][a-z0-9-]{0,254})\/?$/);
      return url.origin === location.origin && match ? root + 'products/' + match[1] : null;
    } catch { return null; }
  }
  function restore() {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const unique = new Map();
      if (Array.isArray(saved)) for (const item of saved) {
        const url = item && typeof item.url === 'string' && productURL(item.url);
        if (url && typeof item.title === 'string') unique.set(url, {url, title:item.title.slice(0,300)});
      }
      items = [...unique.values()].slice(0,3);
    } catch { items = []; }
  }
  function save(message) {
    try { localStorage.setItem(storageKey, JSON.stringify(items)); }
    catch { message += ' This selection will last while this page is open.'; }
    announcement.textContent = message;
    sync();
  }
  function sync() {
    document.querySelectorAll('[data-compare-toggle]').forEach(button => {
      const url = productURL(button.dataset.compareToggle);
      if (!url) return;
      const selected = items.some(item => item.url === url);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      const accessibleLabel = selected ? 'Remove ' + button.dataset.compareTitle + ' from comparison' : 'Compare ' + button.dataset.compareTitle;
      button.setAttribute('aria-label', accessibleLabel);
      button.setAttribute('title', accessibleLabel);
      const label = button.querySelector('[data-compare-label]');
      if (label && label.textContent !== (selected ? 'Added' : 'Compare')) label.textContent = selected ? 'Added' : 'Compare';
    });
    dock.hidden = items.length === 0;
    document.body.toggleAttribute('data-dut-compare-active', items.length > 0);
    dock.querySelector('[data-compare-count]').textContent = items.length === 1 ? '1 selected. Add another.' : items.length + ' products selected';
    openButton.disabled = items.length < 2;
  }
  function remove(url) {
    items = items.filter(item => item.url !== url);
    save('Product removed from comparison.');
    if (dialog.open) {
      if (items.length < 2) dialog.close();
      else { render(); dialog.querySelector('.dut-comparison__remove')?.focus(); }
    }
  }
  function imageURL(value) {
    if (typeof value !== 'string') return null;
    try {
      const url = new URL(value, location.origin);
      if (!['http:','https:'].includes(url.protocol)) return null;
      if (url.origin !== location.origin && !/(^|\.)shopify\.com$|(^|\.)shopifycdn\.com$/.test(url.hostname)) return null;
      url.searchParams.set('width','280');
      return url.href;
    } catch { return null; }
  }
  function price(product) {
    const amount = product.price_min ?? product.price;
    if (typeof amount !== 'number' || !Number.isFinite(amount) || amount < 0) return 'See product for price';
    const currency = dialog.dataset.currency || 'AUD';
    let formatted;
    try { formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency,currencyDisplay:'code'}).format(amount / 100); }
    catch { formatted = currency + ' ' + (amount / 100).toFixed(2); }
    return (product.price_varies === true ? 'From ' : '') + formatted;
  }
  function options(product) {
    const names = (Array.isArray(product.options) ? product.options : []).map(option => typeof option === 'string' ? option : option?.name).filter(name => typeof name === 'string' && name && name !== 'Title');
    return product.variants?.length > 1 ? 'Choose ' + (names.length ? names.join(' / ').toLowerCase() : 'options') + ' on product page' : product.variants?.length === 1 ? 'One option' : 'See product for options';
  }
  const catalogueText = value => typeof value === 'string' && value.trim() ? value.trim() : 'Not provided';
  function showDifferences() {
    let visible = 0;
    tableWrap.querySelectorAll('[data-comparison-row]').forEach(row => {
      row.hidden = differences.checked && row.dataset.same === 'true';
      if (!row.hidden) visible++;
    });
    const hasErrors = items.some(item => !products.get(item.url));
    retryButton.hidden = !hasErrors;
    status.textContent = hasErrors ? 'Some product details could not be loaded. Open the product page or try again.' : differences.checked && !visible ? 'The listed details match. Open each product for its full description.' : '';
  }
  function render() {
    const table = document.createElement('table');
    table.className = 'dut-comparison__table';
    const caption = text('caption', 'Product prices, availability and listed specifications', 'visually-hidden');
    table.append(caption);
    const head = document.createElement('thead'), header = document.createElement('tr');
    const first = text('th','Product'); first.scope = 'col'; header.append(first);
    for (const item of items) {
      const product = products.get(item.url);
      const cell = document.createElement('th'); cell.scope = 'col';
      const image = product?.featured_image && imageURL(product.featured_image);
      if (image) { const img = document.createElement('img'); img.src = image; img.alt = ''; img.width = 180; img.height = 115; img.className = 'dut-comparison__product-image'; cell.append(img); }
      const link = text('a',product?.title || item.title,'dut-comparison__product-title'); link.href = item.url; cell.append(link);
      const removeButton = text('button','Remove','dut-comparison__remove'); removeButton.type = 'button'; removeButton.setAttribute('aria-label','Remove ' + (product?.title || item.title) + ' from comparison'); removeButton.addEventListener('click',()=>remove(item.url)); cell.append(removeButton);
      if (!product) cell.append(text('p','Details unavailable','dut-comparison__missing'));
      header.append(cell);
    }
    head.append(header); table.append(head);
    const body = document.createElement('tbody');
    const facts = items.map(item => window.DutProductFacts.extract(products.get(item.url) || {}));
    const keys = new Map();
    for (const list of facts) for (const fact of list) if (!keys.has(fact.key)) keys.set(fact.key,fact.label);
    const rows = [
      ['Price', items.map(item => { const p=products.get(item.url); return p ? price(p) : 'Unavailable'; })],
      ['Availability', items.map(item => { const p=products.get(item.url); return p?.available === true ? 'Available to order' : p?.available === false ? 'Sold out' : 'Unavailable'; })],
      ['Brand', items.map(item => catalogueText(products.get(item.url)?.vendor))],
      ['Product type', items.map(item => catalogueText(products.get(item.url)?.type))],
      ['Options', items.map(item => { const p=products.get(item.url); return p ? options(p) : 'Unavailable'; })],
      ...[...keys].map(([key,label])=>[label,facts.map(list=>list.find(fact=>fact.key===key)?.value || 'Not provided')])
    ];
    for (const [label,values] of rows) {
      const row = document.createElement('tr'); row.dataset.comparisonRow = '';
      row.dataset.same = String(new Set(values.map(value=>value.trim().toLowerCase())).size === 1);
      const title = text('th',label); title.scope='row'; row.append(title);
      for (const value of values) row.append(text('td',value,value === 'Not provided' || value === 'Unavailable' ? 'dut-comparison__missing' : ''));
      body.append(row);
    }
    const actions = document.createElement('tr'), actionLabel = text('th','Full details'); actionLabel.scope='row'; actions.append(actionLabel);
    for (const item of items) { const cell = document.createElement('td'), link = text('a','View product','dut-comparison__view'); link.href=item.url; cell.append(link); actions.append(cell); }
    body.append(actions); table.append(body);
    tableWrap.replaceChildren(table); tableWrap.removeAttribute('aria-busy');
    differences.disabled = false;
    showDifferences();
  }
  async function load() {
    request?.abort();
    const controller = new AbortController();
    request = controller;
    const current = ++generation, snapshot = items.slice();
    const restoreRetryFocus = document.activeElement === retryButton;
    tableWrap.replaceChildren(); tableWrap.setAttribute('aria-busy','true'); differences.disabled = true;
    retryButton.hidden = true;
    status.textContent = 'Loading current product details…';
    const timeout = setTimeout(()=>controller.abort(),12000);
    const signal = controller.signal;
    try {
      const response = await Promise.allSettled(snapshot.map(async item => {
        const result = await fetch(item.url + '.js', {signal,credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!result.ok) throw new Error('Product unavailable');
        const data = await result.json();
        if (!data || typeof data.title !== 'string' || !Array.isArray(data.variants)) throw new Error('Invalid product');
        return data;
      }));
      if (current !== generation || !dialog.open) return;
      products = new Map(snapshot.map((item,i)=>[item.url,response[i].status === 'fulfilled' ? response[i].value : null]));
      render();
      if (restoreRetryFocus) (retryButton.hidden ? differences : retryButton).focus({preventScroll:true});
    } finally { clearTimeout(timeout); }
  }
  document.addEventListener('click',event=>{
    const toggle = event.target.closest('[data-compare-toggle]');
    if (toggle) {
      event.preventDefault();
      const url = productURL(toggle.dataset.compareToggle); if (!url) return;
      if (items.some(item=>item.url===url)) { remove(url); return; }
      if (items.length === 3) { announcement.textContent='You can compare up to three products. Clear a selection to add this one.'; openButton.focus(); return; }
      items.push({url,title:toggle.dataset.compareTitle || 'Product'}); save('Product added. ' + items.length + ' selected for comparison.');
    }
    if (event.target.closest('[data-compare-open]') && items.length >= 2) {
      returnFocus=document.activeElement; differences.checked=false; document.documentElement.classList.add('dut-comparison-open'); dialog.showModal(); load();
    }
    if (event.target.closest('[data-compare-close]')) dialog.close();
    if (event.target.closest('[data-compare-retry]') && dialog.open) load();
    if (event.target.closest('[data-compare-clear]')) { items=[]; save('Comparison cleared.'); if (dialog.open) dialog.close(); }
    if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close(); }
  });
  dialog.addEventListener('close',()=>{generation++;request?.abort();document.documentElement.classList.remove('dut-comparison-open');const target=returnFocus?.isConnected&&!returnFocus.disabled&&!dock.hidden?returnFocus:document.querySelector('[data-compare-toggle]:not([hidden])');target?.focus({preventScroll:true});});
  dialog.addEventListener('keydown',event=>{
    if (event.key !== 'Tab' || !dialog.open) return;
    const controls=[...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(element=>element.getClientRects().length);
    const first=controls[0], last=controls[controls.length-1];
    if (event.shiftKey && document.activeElement===first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement===last) { event.preventDefault(); first?.focus(); }
  });
  differences.addEventListener('change',showDifferences);
  window.addEventListener('storage',event=>{if(event.key===storageKey){restore();sync();if(dialog.open){if(items.length<2)dialog.close();else load();}}});
  let scheduled=false;
  new MutationObserver(records=>{
    if (scheduled || !records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches('[data-compare-toggle]')||node.querySelector('[data-compare-toggle]'))))) return;
    scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});
  }).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
  restore(); sync();
})();
